import React from 'react'

import { TbListNumbers } from 'react-icons/tb'

import { useIntl } from '@app/intl/Intl'
import { BlockButton } from '@app/lib/inputs/RichEditor/blocks/BlockButton'
import { ListElementType } from '@app/lib/inputs/RichEditor/types'

export const NumberedListButton = () => {
  const { formatMessage } = useIntl()

  return (
    <BlockButton
      format={ListElementType.NumberedList}
      icon={<TbListNumbers />}
      aria-label={formatMessage({ id: 'RichEditor.Element.NumberedList' })}
    />
  )
}
